import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'

import MobileMenu from '../../components/MobileMenu'
import Header from '../../components/Header'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Select from '../../components/Select'
import TextAreaPage from '../../components/TextAreaPage'
import { ToastContainer, toast } from 'react-toastify';
import api from '../../services/api'
import TableListPages from '../../components/TableListPages'
import app from '../../firebase/config'
import { PagesContext } from '../../context/pages'
import ModalEditPage from '../../components/ModalEditPage'
import Input from '../../components/Input'

import Filter from '../../components/Filter'

const CardWrapper = styled.section`
    background-color: #fafafa;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        padding: 1.7rem;

        display: flex;
        flex:1;
        height: 100vh;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`
const CardData = styled.div`
    display:flex;
    justify-content:center;
    flex-direction: column;
    align-items: center;

    div > select{
        width: 100%;
    }

`
const CardTextArea = styled.div`
    margin-top:1.2rem;
    p{
        margin-right: 1rem;
        font-family: "Poppins";
        font-weight: 400;
        font-style: normal;
        margin-bottom: 0.9rem;
    }
`
const CardInput = styled.section`

    display: flex;
    width: 100%;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.2rem;
    }

    div{
        margin-right:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;
        div{
            margin-left: 0rem;
        }

    }


`
const PreviewBanner = styled.div`
   p{
        margin-right: 1rem;
        font-family: "Poppins";
        font-weight: 400;
        font-style: normal;
        margin-bottom: 0.9rem;
    }
`
const BannerImage = styled.img`

    width: 100%;
    height: 320px;
    object-fit: cover;

    

`

const Pages = () => {
    const {getAllPages,setShowModalEditPage,showModalEditPage,getPagesByName} = useContext(PagesContext)
    
    const [data] = useState([
        {
            name: "Id"
        },
        {
            name: "Nome"
        },
        {
            name: "Editar"
        },

        {
            name:"Excluir"
        }
    ])
    const [modalShow, setModalShow] = useState(false)
    const [imagePreview, setImagePreview] = useState()
    const [buttons,setButtons] = useState([])
    const [page] = useState([
        {
            name_page:"",
            name:"",
            image:"",
            description:"",
            
        }
    ])
    const handleInput = (name, value) => {

        page[0][name] = value

    }
    const handleSave = async () => {
        const hasEmptyField = page.some(item =>
            Object.entries(item)
                .filter(([key]) => key !== "description") // Ignora o campo description
                .some(([_, value]) => value === "")
        );
    
        if (hasEmptyField) {
            return toast.error("Existem campos vazios!", {
                autoClose: 1500
            });
        }
    
        await storageImages();
        window.location.href = "/dashboard/pages";
    };
    const getData = async () => {
        const response = await api.get("buttons/get/all")
        setButtons(response.data)
    }
    const storageImages = async () => {

        const loadingToastId = toast.loading("Processando Página...");
        return app.storage().ref(`/pages/images/${page[0].name}`).put(page[0].image)
            .then(() => {
                console.log(`Imagem ${page[0].name} carregada com sucesso`);
                return app.storage().ref(`/pages/images/${page[0].name}`).getDownloadURL();
            })
            .then(image => {
                toast.update(loadingToastId, {
                    render: "Página inserida com sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 1000
                });
                return api.post("pages/storage",{
                    name_page:page[0].name_page,
                    description: localStorage.getItem("@CONTENT_DESCRIPTION_PAGE"),
                    button_name:page[0].name,
                    image:image
                })


            })
            .catch(error => {
                console.error(`Erro ao carregar a imagem ${page[0].name}:`, error);
            });


    }


    useEffect(() => {
        getData()
    },[])

    function ModalPage(props) {
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Informações da página
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <CardInput>
                        <Input name={"Nome da página *"} onChange={(e) => handleInput("name_page",e.target.value)} />
                    </CardInput>
                    <CardInput>
                        <Select name="Botão da página *" data={buttons} target={"name"}  onChange={(e) => handleInput("name",e.target.value)} />
                        <Input name={"Banner da página *"} accept={".png, .jpg, .jpeg"} onChange={(e) => handleInput("image",e.target.files[0])} type={"file"} />
                    </CardInput>
                    <CardData>
                        {imagePreview 
                        
                        ?
                        <PreviewBanner>
                            <p>Preview Banner*</p>
                            <BannerImage src={imagePreview} />
                        </PreviewBanner>           
                        :
                        <></>
                        }
         
                        <CardTextArea>
                            <p>Descrição da página *</p>
                            <TextAreaPage type={"update"} />
                        </CardTextArea>
                    </CardData>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => handleSave()}>Salvar</Button>
                </Modal.Footer>
            </Modal>
        );
    }
 
    function ModalEditPageEl(props) {
        return (
            <ModalEditPage props={props}/>
        );
    }
 
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper>
                <div className='colum_primary'>
                    <SidebarEl />
                </div>
                <FixWidthSidebar />

                <div className='colum_secondary'>
                    <Header name={"Minhas Páginas"} />
                    <Filter onChange={(e) => getPagesByName(e.target.value)} buttonName={"Adicionar"} onClick={() => setModalShow(true)} type={1} />
                    <TableListPages structure={data} />

                </div>

                <MobileMenu />

                <ModalPage
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
                <ModalEditPageEl
                    show={showModalEditPage}
                    onHide={() => setShowModalEditPage(false)}

                />

            

            </CardWrapper>

        </motion.div>

    )
}

export default Pages